import Cookies from 'js-cookie';

export const StorageService = {

	get(key) {
		return Cookies.get(key);
	},

	set(key, val) {
		return Cookies.set(key, val);
	},

	remove(key) {
		return Cookies.remove(key);
	}
};

export default StorageService;
